module.exports = __webpack_public_path__ + "img/18.401fd351.jpg";